module.exports = __webpack_public_path__ + "5987a9ff2dca622508f7cc989fc10bfa.pdf";